import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { SCRIVE_TYPE } from '@treyd-io/core/constants/auth';
import { Col } from '@treyd-io/treyd-ui/components/Grid/Col';
import { Row } from '@treyd-io/treyd-ui/components/Grid/Row';
import ArrowRightIcon from '@treyd-io/treyd-ui/icons/ArrowRightIcon';

import { useTranslation } from 'react-i18next';

export const BankIdDialogBody = ({
  onSubmit,
  onSignWithVerificationCodeClick,
  type,
}: {
  onSubmit: () => void;
  onSignWithVerificationCodeClick: () => void;
  type: SCRIVE_TYPE;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <DialogContent>
        <Typography color="text.secondary" variant="body1">
          {type === SCRIVE_TYPE.SIGN && t('sign_with_bank_id_description')}
          {type === SCRIVE_TYPE.AUTH && t('confirm_with_bank_id_description')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Row>
          <Col xs={12} sm="auto">
            <Button
              size="large"
              fullWidth
              variant="contained"
              onClick={onSubmit}
              endIcon={<ArrowRightIcon />}>
              {t('continue')}
            </Button>
          </Col>
          <Col xs={12} sm="auto">
            <Button
              type="button"
              color="info"
              fullWidth
              size="large"
              onClick={onSignWithVerificationCodeClick}>
              {type === SCRIVE_TYPE.SIGN &&
                t('sign_with_verification_code_instead')}
              {type === SCRIVE_TYPE.AUTH &&
                t('confirm_with_verification_code_instead')}
            </Button>
          </Col>
        </Row>
      </DialogActions>
    </>
  );
};
